import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { columnMinWidth } from '../../../../utils/tableUtils';
/**
 *
 * @param props
 * @return {*}
 * @constructor
 */
export default function TableHeaderColumn(props) {
    var classes = classNames({
        'align-text-top': true,
        'text-nowrap': !props.wrapText,
        'text-right': props.rightAlign,
        'sort': !!props.sortBy
    }) + ' ' + props.className;
    return React.createElement("th", { className: classes, style: props.compact ? columnMinWidth : null, "data-sort": props.sortBy },
        React.createElement(FormattedMessage, { id: props.labelId, defaultMessage: props.label }));
}
TableHeaderColumn.defaultProps = {
    className: '',
    label: '',
    compact: true,
    wrapText: false
};
